export const setTheme = (colors: { [x: string]: string | null }) => {
  if (colors) {
    Object.keys(colors).forEach((cssKey) => {
      document.documentElement.style.setProperty(`--${cssKey}`, colors[cssKey]);
    });
  }
};
